import {
  AutomationActionTemplate,
  AutomationActionType
} from '@dadohr/shared/domainTypes/experience';
import { Integration } from '@dadohr/shared/domainTypes/integrations';

export enum AutomationActionKey {
  ASANA_CREATE_TASK = 'ASANA_CREATE_TASK',
  ATLASSIAN_CREATE_ISSUE = 'ATLASSIAN_CREATE_ISSUE',
  DOCEBO_ENROLL = 'DOCEBO_ENROLL',
  ENROLL_IN_EXPERIENCE = 'ENROLL_IN_EXPERIENCE',
  GOOGLE_ADD_TO_GROUP = 'GOOGLE_ADD_TO_GROUP',
  GOOGLE_CALENDAR_EVENT_INVITATION = 'GOOGLE_CALENDAR_EVENT_INVITATION',
  LESSONLY_ASSIGN_TO_CONTENT = 'LESSONLY_ASSIGN_TO_CONTENT',
  MS_OUTLOOK_ADD_TO_GROUP = 'MS_OUTLOOK_ADD_TO_GROUP',
  MS_OUTLOOK_CALENDER_EVENT_INVITATION = 'MS_OUTLOOK_CALENDER_EVENT_INVITATION',
  OKTA_ADD_TO_GROUP = 'OKTA_ADD_TO_GROUP',
  MS_TEAMS_INVITE_TO_CHANNEL = 'MS_TEAMS_INVITE_TO_CHANNEL',
  SLACK_INVITE_TO_CHANNEL = 'SLACK_INVITE_TO_CHANNEL',
  CREATE_DOCUMENT_FROM_TEMPLATE_MS = 'CREATE_DOCUMENT_FROM_TEMPLATE@MS',
  CREATE_DOCUMENT_FROM_TEMPLATE_GOOGLE = 'CREATE_DOCUMENT_FROM_TEMPLATE@GOOGLE',
  HTTP_POST = 'HTTP_POST',
  UNENROLL_FROM_EXPERIENCE = 'UNENROLL_FROM_EXPERIENCE',
  SYNC_TO_DATA_DESTINATION = 'SYNC_TO_DATA_DESTINATION'
}

export type ActionDefinition = {
  key: AutomationActionKey;
  type: AutomationActionType;
  iconSrc: string;
  label: string;
  shortLabel: string;
  description?: string;
  emptyAction: () => AutomationActionTemplate;
  enabled: boolean;
  parentIntegration: Integration | null;
};
